// extracted by mini-css-extract-plugin
module.exports = {"alerts":"alerts_alerts__23vKH","alertList":"alerts_alertList__1nk4K"};